function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m494.925 105.815c-.184-.405-.394-.793-.628-1.167-1.226-2.156-2.737-4.167-4.525-5.976l-89.161-90.206c-2.258-2.285-4.892-4.151-7.753-5.548-.047-.026-.095-.047-.142-.072-.065-.031-.129-.063-.194-.093-.265-.133-.536-.254-.814-.363-3.566-1.552-7.441-2.39-11.367-2.39h-156.832c-15.715 0-28.5 12.785-28.5 28.5v76.929h-152.511c-15.715 0-28.5 12.784-28.5 28.499v349.572c0 15.715 12.785 28.5 28.5 28.5h243.948c15.715 0 28.5-12.785 28.5-28.5v-76.929h154.555c15.715 0 28.5-12.784 28.5-28.499v-259.366c0-4.552-1.069-8.943-3.076-12.891zm-32.02-5.874h-56.342c-4.687 0-8.5-3.813-8.5-8.5v-57.101zm-247.896 39.828 64.841 65.602h-56.341c-4.687 0-8.5-3.813-8.5-8.5zm79.938 343.731c0 4.687-3.813 8.5-8.5 8.5h-243.949c-4.687 0-8.5-3.813-8.5-8.5v-349.572c0-4.687 3.813-8.499 8.5-8.499h152.511v71.441c0 15.715 12.785 28.5 28.5 28.5h71.438v34.857h-32.042c-5.523 0-10 4.478-10 10s4.477 10 10 10h32.042zm174.555-96.929h-154.555v-106.343h67.979l-23.01 22.914c-3.914 3.897-3.927 10.229-.03 14.143 1.954 1.962 4.52 2.943 7.086 2.943 2.552 0 5.105-.971 7.056-2.914l40-39.833c1.879-1.871 2.938-4.413 2.944-7.065 0-.032-.004-.064-.005-.097 0-.031.005-.06.005-.091 0-3.279-1.586-6.181-4.024-8.004l-38.89-39.052c-3.897-3.913-10.229-3.927-14.142-.029s-3.927 10.229-.03 14.143l22.848 22.943h-67.787v-36.093c0-7.55-2.923-14.665-8.23-20.034l-89.161-90.206c-.802-.812-1.656-1.564-2.546-2.268v-83.128c0-4.687 3.813-8.5 8.5-8.5h154.555v71.441c0 15.715 12.785 28.5 28.5 28.5h71.438v258.131c-.002 4.687-3.815 8.499-8.501 8.499z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m79.248 280h131.647c5.523 0 10-4.478 10-10s-4.477-10-10-10h-131.647c-5.523 0-10 4.478-10 10s4.477 10 10 10z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m79.248 333h109.723c5.523 0 10-4.478 10-10s-4.477-10-10-10h-109.723c-5.523 0-10 4.478-10 10s4.477 10 10 10z"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 238.738,
  cy: 323,
  r: 10.005
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m238.971 366.667h-159.723c-5.523 0-10 4.478-10 10s4.477 10 10 10h159.723c5.523 0 10-4.478 10-10s-4.477-10-10-10z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m238.971 420h-159.723c-5.523 0-10 4.478-10 10s4.477 10 10 10h159.723c5.523 0 10-4.478 10-10s-4.477-10-10-10z"
});

var SvgFiles = function SvgFiles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFiles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files.01d8833a.svg";
export { ForwardRef as ReactComponent };